// src/app/videos/ProblemCard.tsx
//
// One worked problem, as prose. Shared by the static page (the free first problem) and the
// client-side gate (the rest, once the API has released them), so the two halves of the
// list cannot drift apart. No hooks — renders on the server and in the browser alike.
// `ask` adds the "Ask Sage about this problem" button (it hides itself when Sage can't open).

import AskSageButton from '@/components/tutor/AskSageButton'
import type { AskSageRequest } from '@/lib/tutor/on-screen-material'
import type { Problem } from '@/lib/content/video-catalog'

export default function ProblemCard({ p, ask }: { p: Problem; ask?: AskSageRequest }) {
  return (
    <div className="rounded-lg border border-border bg-card/40 p-4">
      <p className="font-mono text-sm font-semibold">{p.given}</p>
      <p className="mt-1 text-sm text-muted-foreground">{p.ask}</p>
      <p className="mt-3 text-sm leading-relaxed text-foreground/90">{p.how}</p>
      <p className="mt-3 text-sm font-semibold text-brand-ink">Answer: {p.answer}</p>
      {ask && (
        <div className="mt-2 -ml-2">
          <AskSageButton request={ask}>Ask Sage about this problem</AskSageButton>
        </div>
      )}
    </div>
  )
}
